import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const Menu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Leer estado inicial desde localStorage (por defecto abierto)
  const [isOpen, setIsOpen] = useState(() => {
    const saved = localStorage.getItem("menuOpen");
    return saved === null ? true : saved === "true";
  });

  // Estado solo para móvil (no se persiste)
  const [mobileOpen, setMobileOpen] = useState(false);

  // Guardar cambio en localStorage para persistencia (desktop)
  useEffect(() => {
    localStorage.setItem("menuOpen", isOpen ? "true" : "false");
  }, [isOpen]);

  // Bloquear scroll del body cuando el menú móvil esté abierto
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const cerrarSesion = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("idEstablecimiento");
    // cerrar menú móvil si está abierto
    setMobileOpen(false);
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  // Items comunes para no repetir
  const MenuItems = ({ onClickLink }) => (
    <ul className="space-y-3 px-2 mt-[10px]" >
      <li className={`flex items-center w-full ${isActive('/Perfil') ? 'text-indigo-700 font-medium' : ''} `}>
        <Link to="/Perfil" onClick={onClickLink} className={`flex items-center w-full ${isOpen ? 'justify-start' : 'justify-center'}`}>
          <i className={`fas fa-user-circle ${isActive('/Perfil') ? 'text-[#847de5]' : 'text-white'} text-2xl`}></i>
          {isOpen && <span className="ml-2 text-white">Perfil</span>}
        </Link>
      </li>
      <li className={`flex items-center w-full ${isActive('/Eventos') ? 'text-indigo-700 font-medium' : ''}`}>
        <Link to="/Eventos" onClick={onClickLink} className={`flex items-center w-full ${isOpen ? 'justify-start' : 'justify-center'}`}>
          <i className={`fas fa-calendar-alt ${isActive('/Eventos') ? 'text-[#847de5]' : 'text-white'} text-2xl`}></i>
          {isOpen && <span className="ml-2 text-white">Eventos</span>}
        </Link>
      </li>
      <li className={`flex items-center w-full ${isActive('/Inventario') ? 'text-indigo-700 font-medium' : ''}`}>
        <Link to="/Inventario" onClick={onClickLink} className={`flex items-center w-full ${isOpen ? 'justify-start' : 'justify-center'}`}>
          <i className={`fas fa-box-open ${isActive('/Inventario') ? 'text-[#847de5]' : 'text-white'} text-2xl`}></i>
          {isOpen && <span className="ml-2 text-white">Inventario</span>}
        </Link>
      </li>
    </ul>
  );

  return (
    <>
      {/* Botón móvil (solo visible en pantallas pequeñas) */}
      {/* <button
        className="md:hidden fixed  top-3 z-50 bg-indigo-100 rounded-md px-3 py-2 shadow"
        onClick={() => setMobileOpen(true)}
        aria-label="Abrir menú"
      >
        ≡
      </button> */}

      {/* Sidebar desktop: visible en md+ */}
      <div id="CuadrosEstandar" className={`hidden md:flex fixed left-0 top-0 h-screen z-40 shadow-md text-sm flex-col justify-between py-6 transition-all duration-300 ${isOpen ? "w-56" : "w-16"}`}>
        <div>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="bg-indigo-100 rounded-md px-2 py-2 font-semibold w-full"
            aria-label="Colapsar menú"
          >
            {isOpen ? "Eventorys" : "≡"}
          </button>

          <MenuItems onClickLink={() => {}} />
        </div>

        <button
          className={`text-xs text-white px-4 text-left ${!isOpen ? "text-center px-0" : ''}`}
          onClick={cerrarSesion}
        >
          {isOpen ? "⏎ Cerrar sesión" : <i className="fas fa-sign-out-alt text-white text-2xl"></i>}
        </button>
      </div>

      {/* Menú móvil deslizable */}
      {mobileOpen && (
        <div className="md:hidden fixed left-0 top-0 h-screen z-50 bg-white w-64 shadow-lg flex flex-col justify-between transition-transform">
          <div>
            <div className="flex items-center justify-between px-3 py-3 border-b">
              <div className="font-semibold">Menú</div>
              <button onClick={() => setMobileOpen(false)} className="px-2 py-1 rounded bg-indigo-100">✕</button>
            </div>

            {/* Forzar isOpen a true para mostrar labels en móvil */}
            <div className="py-4 px-2">
              {/* temporalmente mostramos las etiquetas en móvil */}
              <ul className="space-y-3">
                <li className={`flex items-center w-full ${isActive('/Perfil') ? 'text-indigo-700 text-black font-medium ' : ''} `}>
                  <Link to="/Perfil" onClick={() => setMobileOpen(false)} className="flex items-center w-full justify-start">
                    <i className="fas fa-user-circle text-white" size="10px"></i>
                    <span className="ml-2 text-white">Perfil</span>
                  </Link>
                </li>
                <li className={`flex items-center w-full ${isActive('/Eventos') ? 'text-indigo-700 text-[#9d98ba] font-medium' : ''}`}>
                  <Link to="/Eventos" onClick={() => setMobileOpen(false)} className="flex items-center w-full justify-start">
                    <i className="fas fa-calendar-alt text-white"></i>
                    <span className="ml-2 text-white">Eventos</span>
                  </Link>
                </li>
                <li className={`flex items-center w-full ${isActive('/Inventario') ? 'text-indigo-700 text-[#9d98ba] font-medium ' : ''}`}>
                  <Link to="/Inventario" onClick={() => setMobileOpen(false)} className="flex items-center w-full justify-start">
                    <i className="fas fa-box-open text-white"></i>
                    <span className="ml-2 text-white">Inventario</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <button
            className="text-sm text-indigo-700 px-4 text-left border-t py-3 text-white text-2xl"
            onClick={() => { cerrarSesion(); setMobileOpen(false); }}
          >
            ⏎ Cerrar sesión
          </button>
        </div>
      )}
    </>
  );
};

export default Menu;
